/**
 * A post on its own page: where a shared link (/feed/<author>/posts/<post>/) and a click on a post lead.
 * The post as the viewer may see it, with its comments; a clear message when it was deleted or is not
 * shared with them. Backend: GET /interact/posts/<id>/ (the visibility rules decide).
 */
import React from 'react';
import useSWR from 'swr';
import { useNavigate, useParams } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import { fetcher } from 'shared/helpers/axios';
import { useUserContext } from 'shared/contexts/UserContext';
import PageContainer from 'components/common/layout/PageContainer';
import BackButton from 'components/common/buttons/BackButton';
import PostItem from 'components/common/PostItem';

export default function PostPage() {
  const { postId } = useParams();
  const navigate = useNavigate();
  const { user } = useUserContext();
  const { data: post, error, isLoading } = useSWR(postId ? `/interact/posts/${postId}/` : null, fetcher);

  return (
    <PageContainer width="narrow">
      <Box onClick={() => navigate(-1)}
        sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25, mb: 1.5, cursor: 'pointer', color: 'text.secondary',
          '&:hover': { color: 'primary.main' } }}>
        <BackButton position="inline" onClick={() => {}} sx={{ color: 'inherit', '&:hover': { color: 'inherit' } }} />
        <Typography variant="body1" fontWeight={500} sx={{ color: 'inherit' }}>Back</Typography>
      </Box>
      {isLoading && <Box display="flex" justifyContent="center" py={6}><CircularProgress /></Box>}
      {error && (
        <Alert severity="info" action={<Button color="inherit" size="small" onClick={() => navigate('/')}>Home</Button>}>
          {error.response?.status === 404
            ? 'This post was deleted, or its author did not share it with you.'
            : 'The post could not be loaded. Please try again.'}
        </Alert>
      )}
      {/* the post is its own card, as on the feed: no box around it */}
      {post && <PostItem post={post} currentUser={user} />}
    </PageContainer>
  );
}
